const remindOptions = {
    '': 'Без напоминания',
    '1': '1 час',
    '2': '2 часа',
    '3': '3 часа',
    '4': '4 часа',
    '5': '5 часов',
    '6': '6 часов',
    '7': '7 часов',
    '8': '8 часов',
    '9': '9 часов',
    '10': '10 часов',
    '11': '11 часов',
    '12': '12 часов',
    '24': '24 часа'
};

export default remindOptions;